import React, { Component } from 'react'
import { Row, Typography } from 'antd'
import { Map, APILoader, Polyline } from '@uiw/react-baidu-map';
// import Title from 'antd/lib/skeleton/Title';

const { Title } = Typography;

export default class PlaneTrackMap extends Component {
    render(){
        if (this.props.tracks.length === 0){
            return
        }
        const {tracks, key} = this.props
        var avgLat=0, avgLon=0
        
        if (tracks && tracks.length>0){
            var maxLat=0,minLat=0,maxLon=0,minLon = 0
            tracks.map((track)=>{
                track.map(e=>{
                    if (e.lat > maxLat || maxLat===0){
                        maxLat = e.lat
                    }
                    if (e.lon > maxLon || maxLon===0){
                        maxLon = e.lon
                    }
                    if (e.lat < minLat || minLat===0){
                        minLat = e.lat
                    }
                    if (e.lon < minLon || minLon===0){
                        minLon = e.lon
                    }   
                    return ""                 
                })
                return ""
            })
            avgLat = (maxLat+minLat)/2
            avgLon = (maxLon+minLon)/2
        }
        

        // center={{lng: avgLon, lat: avgLat}}
        return(
            <Row align='middle' justify='center'>
                <Title level={5} style={{textAlign:'center', color:'white'}}>近30日活动轨迹</Title>
                <div style={{ width: '65vw', height: '60vh'}}>
                    <APILoader akay="PBY8a0Srye77leaBnETSUiuGGmARNiTj">
                    <Map key={key} center={{lng: avgLon, lat: avgLat}} zoom={1}>
                        {tracks.map((track)=>{
                            var path = []
                            track.map((e)=>
                                path.push({lng: e.lon, lat: e.lat })
                            )
                            if (path.length>1) {
                                return <Polyline key={key} strokeOpacity={1} path={path} />
                            }else{
                                return ""
                            }                        
                        })} 
                    </Map>
                    </APILoader>
                </div>
            </Row>
        )
    }
}